'use client';

import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { CaretDown, CaretRight } from "../../../react-icons.js";
import { useId } from "../../utils/hooks/useId.js";
import { Text } from "../../atoms/Text/Text.js";
import { container, headerContainer, header, button, contentWrapper } from "./ExpandableMenuSection.css.js";
function ExpandableMenuSectionComponent({
  a11yLabel,
  dataQa,
  children,
  titleItem,
  open,
  title,
  onToggle
}) {
  const autoId = useId();
  const expandableMenuSectionId = `expandable-menu-section-${autoId}`;
  const handleToggle = (newIsOpen) => {
    onToggle == null ? void 0 : onToggle(newIsOpen);
  };
  const commonStyles = {
    display: "grid",
    transition: "grid-template-rows 0.2s ease-out, margin-top 0.2s ease-out"
  };
  const openStyles = {
    gridTemplateRows: "1fr"
  };
  const closedStyles = {
    gridTemplateRows: "0fr"
  };
  return /* @__PURE__ */ jsxs("section", { className: container, "data-qa": dataQa, children: [
    /* @__PURE__ */ jsxs("div", { className: headerContainer, children: [
      /* @__PURE__ */ jsx("div", { className: header, children: /* @__PURE__ */ jsxs(
        "button",
        {
          "aria-controls": expandableMenuSectionId,
          "aria-expanded": open,
          "aria-label": a11yLabel,
          className: button,
          type: "button",
          onClick: () => handleToggle(!open),
          children: [
            open ? /* @__PURE__ */ jsx(CaretDown, { size: "sm", filled: true }) : /* @__PURE__ */ jsx(CaretRight, { size: "sm", filled: true }),
            /* @__PURE__ */ jsx(Text, { as: "span", variant: "label.sm", children: title })
          ]
        }
      ) }),
      titleItem
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(contentWrapper),
        id: expandableMenuSectionId,
        style: {
          ...commonStyles,
          ...open ? openStyles : closedStyles
        },
        children: /* @__PURE__ */ jsx("div", { style: { overflow: "hidden" }, children })
      }
    )
  ] });
}
const ExpandableMenuSection = /* @__PURE__ */ memo(
  ExpandableMenuSectionComponent
);
export {
  ExpandableMenuSection
};
